import * as React from 'react';
import * as ReactDOM from 'react-dom';
import AviaryShutdownDialog from './AviaryShutdownDialog';
import diyLightTheme = require('diy/material-ui/diyLightTheme');

let dialogContainer: HTMLDivElement;

export interface DiyShutdownDialogState {
    open: boolean;
}

export interface DiyShutdownDialogProps {
    open: boolean;
}

export class DiyShutdownDialog extends React.Component<DiyShutdownDialogProps, DiyShutdownDialogState> {

    static childContextTypes: React.ValidationMap<any> = {
        muiTheme: React.PropTypes.object
    };

    constructor(props: DiyShutdownDialogProps) {
        super(props);
        this.state = {
            open: this.props.open
        };
    }

    getChildContext() {
        return {
            muiTheme: diyLightTheme
        };
    }

    componentWillReceiveProps(props: DiyShutdownDialogProps) {
        this.setState({
            open: props.open
        });
    }

    render() {
        return (
            <AviaryShutdownDialog
                open={this.state.open}
                onClose={this.onClose}
                />
        );
    }

    private onClose = () => {
        this.setState({
            open: false
        });
    };
}

export function showDialog() {
    dialogContainer = document.createElement('div');

    ReactDOM.render(
        <DiyShutdownDialog open={true} />,
        dialogContainer
    );
    document.body.appendChild(dialogContainer);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/aviary/DiyAviaryShutdownDialog.tsx
 **/